export default "__VITE_ASSET__BRBVa$QT__"